import { fetcher } from '@commenda/utils';
import { TEMPLATES_URL } from './helpers';
import { TDocumentAssemblerUpdateTemplateParams } from './types';

export const updateDocumentAssemblerTemplate = async (
  templateId: string,
  data: TDocumentAssemblerUpdateTemplateParams
): Promise<Response> => {
  const res = await fetcher(`${TEMPLATES_URL}/${templateId}`, {
    method: 'POST',
    body: data,
  });
  return res;
};
